import { Skeleton } from "@kyan/ui";

import { ChangeIndicator } from "#/components/ChangeIndicator/ChangeIndicator";
import { type RFQResponseState } from "#/services/kyan/kyan.types";
import { usePositionsDrawerMarket } from "#/store/app/positionsDrawer/positionsDrawerMarket";
import { useAccountState } from "#/store/wallet/account/accountState";
import { getImpactColor } from "#/utils/getImpactColor";

import { useRfqRiskData } from "../../hooks/useRfqRiskData";

interface RfqRiskChangeProps {
  response: RFQResponseState;
  riskMetric: "imr" | "mmr" | "delta" | "gamma" | "vega" | "theta";
  template?: string;
  isPercent?: boolean;
}

export const RfqRiskChange: React.FC<RfqRiskChangeProps> = ({
  response,
  riskMetric,
  template = "0.00",
  isPercent,
}) => {
  const { market } = usePositionsDrawerMarket();
  const { portfolioState } = useAccountState(market.underlying);
  const riskData = useRfqRiskData({ response, portfolioState, market });
  const { from, to } = riskData[riskMetric];

  const isImrMmr = ["imr", "mmr"].includes(riskMetric);
  const rightLabelClassName = isImrMmr ? getImpactColor(to) : "";

  if (riskData.isLoading) {
    return <Skeleton />;
  }

  if (to === 0) {
    return "-";
  }

  return (
    <ChangeIndicator
      to={to}
      from={from}
      template={template}
      isPercent={isPercent}
      rightLabelClassName={rightLabelClassName}
    />
  );
};
